// pages/cart/ui.tsx
import React from 'react'
import { CartLayoutV2 } from 'src/components/cartV2/CartLayoutV2'
import CartContextProvider from 'src/lib/contexts/CartContext'
import { CustomizeUIProvider } from 'src/lib/contexts/CustomizeUIProvider'

const CartUI = () => {
  return (
    <CustomizeUIProvider>
      <CartContextProvider>
        <CartLayoutV2 />
      </CartContextProvider>
    </CustomizeUIProvider>
  )
}

export default CartUI
